"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./styles.module.scss";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import ClickToScroll from "@/components/sections/NewLists/ClickToScroll";
import LeaderCard from "@molecules/LeaderCard/LeaderCard";
import { useMemo } from "react";

export default function CareerMentorsSection({ isDesktop, data }) {
  const items = useMemo(() => {
    return data?.map((x) => ({
      attributes: {
        Image: {
          enabled: true,
          source: x?.Image,
        },
        Name: {
          enabled: !!x?.Name,
          text: x?.Name,
        },
        Designation: {
          enabled: !!x?.Designation,
          text: x?.Designation,
        },
      },
    }));
  }, [data]);

  if (isDesktop) {
    return (
      <div className={styles.root} id="meetOurCareerMentors">
        <ClickToScroll id="meetOurCareerMentors" />
        {items?.map((d, index) => (
          <LeaderCard key={index} item={d} hasFixWidth />
        ))}
      </div>
    );
  }

  return (
    <div className="Carousel px-3">
      <Swiper
        autoplay={{
          delay: 6000,
        }}
        modules={[Pagination, Autoplay]}
        spaceBetween={16}
        slidesPerView={1.1}
        pagination={{ clickable: true }}
        className="Carousel__blueBullet Carousel__hAuto"
      >
        {items?.map((d, index) => (
          <SwiperSlide key={index}>
            <LeaderCard item={d} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
